import { render, staticRenderFns } from "./ImageSpinner.vue?vue&type=template&id=8402c264&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8402c264",
  null
  
)

export default component.exports